'use client'
import { AssistantTypeBadge } from '@/components/molecules/AssistantTypeBadge'
import { type FlatMessage } from '@/utils/flattenConversations'
import Link from 'next/link'
import React, { useEffect, useState } from 'react'

interface FlatChatMessageProps {
	msg: FlatMessage
	onDelete?: (conversationId: string) => void
	showPhaseTag?: boolean
	// Nuevo: delay opcional para simular mensajes secuenciales del asistente
	delayMs?: number
}

export const FlatChatMessage: React.FC<FlatChatMessageProps> = ({ msg, delayMs = 0 }) => {
	const isUser = msg.role === 'user'
	// Render diferido: solo aplicar a mensajes del asistente
	const [visible, setVisible] = useState(isUser || delayMs <= 0)
	useEffect(() => {
		if (isUser || delayMs <= 0) {
			return
		}
		const timer: ReturnType<typeof setTimeout> | undefined = setTimeout(
			() => setVisible(true),
			delayMs
		)
		return () => {
			if (timer) {
				clearTimeout(timer)
			}
		}
	}, [delayMs, isUser, msg.id])

	if (!visible) {
		return null
	}

	return (
		<div className={`mb-3 flex w-full px-2 ${isUser ? 'justify-end' : 'justify-start'}`}>
			<div className={`flex w-full flex-col gap-1 ${isUser ? 'items-end' : 'items-start'}`}>
				{/* Badge de tipo de asistente (nuevo multi-agent system) */}
				{!isUser && msg.assistantType && (
					<div className="mb-1">
						<AssistantTypeBadge type={msg.assistantType} />
					</div>
				)}
				<div
					className={`relative max-w-[80%] px-4 py-2.5 text-[15px] shadow-sm ${
						isUser
							? 'ml-auto rounded-tl-[20px] rounded-tr-[6px] rounded-br-[20px] rounded-bl-[20px] bg-[#E5E5EA] text-[#1c1c1e]'
							: 'mr-auto rounded-tl-[6px] rounded-tr-[20px] rounded-br-[20px] rounded-bl-[20px] bg-[#1565F7] text-white'
					}`}
				>
					<p className="leading-snug whitespace-pre-wrap">{msg.text}</p>

					{/* Cta Button */}
					{msg.metadata?.type === 'uvp_ready' && msg.metadata?.cta && (
						<div className="mt-3 text-right">
							<Link
								href={msg.metadata.cta.url}
								className="inline-block rounded-full bg-white px-4 py-2 text-xs font-bold text-[#1565F7] shadow-sm transition-colors hover:bg-zinc-100"
							>
								{msg.metadata.cta.label}
							</Link>
						</div>
					)}
				</div>
			</div>
		</div>
	)
}

{
	/* uvp_ready CTA removed */
}

export default FlatChatMessage
